import React, { FC } from 'react';
import { Field, ErrorMessage } from 'formik';
import { Checkbox, Typography } from '@getgo/chameleon-web/react';
import { IFormControl } from '../formInterface';
import FormErrorMessageBox from './formErrorMessageBox';

/* Reference links for handling single checkbox with formik:
 * https://stackoverflow.com/a/63240338/5527839
 * https://bit.ly/3DAztkK
 * */
const FormCheckbox: FC<IFormControl> = (props) => {
  const { name, ...rest } = props;

  return (
    <Field name={name} {...rest}>
      {({ form, field }: any) => {
        const { setFieldValue } = form;
        return (
          <>
            <div className="display-flex">
              <Checkbox
                id={name}
                {...field}
                onChange={(e) => setFieldValue(name, e.target.checked)}
              />
              <Typography className="checkbox-text" color="text-01">
                {props.children}
              </Typography>
            </div>
            <ErrorMessage
              name={name}
              render={(errorMessage: string) => (
                <FormErrorMessageBox errorMessage={form.errors[name]} />
              )}
            />
          </>
        );
      }}
    </Field>
  );
};

export default FormCheckbox;
